app.content = {
	// COMMON --------------------------------------------
	// Configs + Constants
	TIMERS: '',
	DATA: '',
	AJAX: '',


	// MAIN FUNCTIONS ------------------------------------
	init: function () {
		console.log('-- app.content.init --');

		this.setupLayout();
		this.setupEvents();

		if($('.js-module-accordion').length){
			app.content.accordion.init();
		}

		if($('.js-module-accordion').length){
			app.content.gallery.init();
		}
	},

	setupEvents: function() {},
	setupLayout: function () {},


	// OTHER FUNCTIONS -----------------------------------
	accordion: {
		init: function(){
			app.content.accordion.events.on();
		},
		events: {
			on: function(){
				$doc
					.on('click', '.js-openAccordion', app.content.accordion.open);
			}
		},
		open: function() {
			var $el = $(this),
				$item = $el.closest('.accordion-item'),
				$panel = $item.find('.panel');

			console.log($panel[0].style.maxHeight, $panel[0].scrollHeight);
			$el.toggleClass('is-active');

			if ($panel[0].style.maxHeight) {
				$panel[0].style.maxHeight = null;
			} else {
				$panel[0].style.maxHeight = $panel[0].scrollHeight + "px";
			}
		}
	},

	gallery: {
		init: function(){
		}
	},


};
